import React from 'react';
import { useParams } from 'react-router-dom';
import ProductCategory from '../ProductCategory/ProductCategory';
import ProductDetail from '../ProductDetail/ProductDetail';
import { getCategoryBySlug } from '../Categories/constant';
import { getProductBySlug } from '../ProductCategory/products';

const ProductOrCategory = () => {
  const { slug } = useParams();
  
  const category = getCategoryBySlug(slug);
  if (category) {
    return <ProductCategory />;
  }
  
  const product = getProductBySlug(slug);
  if (product) {
    return <ProductDetail />;
  }
  
  // If neither found, you might want to show a 404 or redirect
  return <div>Not Found</div>;
};

export default ProductOrCategory;

